import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CustomButton from '../ui/Button/Button';
import PieCharts from '../Charts/PieCharts/PieCharts';
import { findKeyByValue } from './utils';
import { storeNameList } from '../../Container/utils';
import * as XLSX from 'xlsx';
import ReactLoading from 'react-loading';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const values = ['Postpaid', 'Prepaid', 'Device', 'Accessory'];

const DashBoardPieChart = ({
  isLoading,
  accListAR,
  accListOA,
  eventCisData,
  datesString,
  type,
  cisdata = [],
}) => {
  const [PieChartData, setPieChartData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(values[0]);

//   let data = [];
//   let data1 = [];
//   data = accListAR;
//   data1 = accListOA;

//   const combinedArray = [];

//   // Extracting from accListAR
//   data.forEach((item) => {
//     if (item.attachedAcc && item.attachedAcc.length > 0) {
//       combinedArray.push(...item.attachedAcc);
//     }
//   });

  // Extracting from accListOA
//   data1.forEach((item) => {
//     if (item.attachedAccOnlyAccessory && item.attachedAccOnlyAccessory.length > 0) {
//       combinedArray.push(...item.attachedAccOnlyAccessory);
//     }
//   });
//   if (type[0] === undefined && type[1] === undefined) {
//     const filteredData = accListAR.filter((item) => item.user === emailPrefix);
//     const filteredData1 = accListOA.filter((item) => item.username === emailPrefix);
//     data = filteredData;
//     data1 = filteredData1;
//   } else if (type[1] && type[0] === '') {
//     const filteredData = accListAR.filter(
//       (item) => item.storeInvoice === findKeyByValue(storeNameList, type[1]),
//     );
//     const filteredData1 = accListOA.filter(
//       (item) => item.storeInvoiceOA === findKeyByValue(storeNameList, type[1]),
//     );
//     data = filteredData;
//     data1 = filteredData1;
//   } else if (type[1] && type[0]) {
//     const filteredData = accListAR.filter(
//       (item) =>
//         item.storeInvoice === findKeyByValue(storeNameList, type[1]) && item.user === emailPrefix,
//     );
//     const filteredData1 = accListOA.filter(
//       (item) =>
//         item.storeInvoiceOA === findKeyByValue(storeNameList, type[1]) &&
//         item.username === emailPrefix,
//     );
//     data = filteredData;
//     data1 = filteredData1;
//   }

//   // Count frequency of accessory names
//   const frequencyMap = {};
//   combinedArray.forEach((accessory) => {
//     const accessoryName = accessory[1];
//     if (frequencyMap[accessoryName]) {
//       frequencyMap[accessoryName]++;
//     } else {
//       frequencyMap[accessoryName] = 1;
//     }
//   });

//   // Convert frequency map to array and sort by frequency
//   const sortedAccessories = Object.entries(frequencyMap)
//     .sort((a, b) => b[1] - a[1])
//     .map((entry) => ({ name: entry[0], value: entry[1] }));

//   // Slice the top 4 accessories

// //   const top4Accessories = sortedAccessories.slice(0, 5);

//   const combinedCISArray = [...cisdata, ...eventCisData];

//   const counts = combinedCISArray?.reduce(
//     (acc, obj) => {
//       const planName = obj.planName;
//       const phoneMake = obj?.phoneMake?.startsWith(
//         'TCL 60 XE NXTPAPER 5G 128GB Extended Warranty Services',
//       )
//         ? 'TCL 60 XE NXTPAPER 5G 128GB Extended Warranty Services'
//         : obj.phoneMake;
//       const type = obj.connectionType;
//       const sim = obj.simNumber;
//       if (type === 'Prepaid') {
//         acc.prepaidCounts[planName] = (acc.prepaidCounts[planName] || 0) + 1;
//       } else if (type === 'Postpaid' && sim !== '') {
//         acc.postpaidCounts[planName] = (acc.postpaidCounts[planName] || 0) + 1;
//       }
//       if (!phoneMake.includes('Bring Your Own Phone')) {
//         acc.phoneCounts[phoneMake] = (acc.phoneCounts[phoneMake] || 0) + 1;
//       }
//       return acc;
//     },
//     { prepaidCounts: {}, postpaidCounts: {}, phoneCounts: {} },
//   );
//   const sortedPrepaid1 = Object.entries(counts.prepaidCounts)
//     .sort((a, b) => b[1] - a[1])
//     .map((entry) => ({ name: entry[0], value: entry[1] }));
// //   const sortedPrepaid = sortedPrepaid1.slice(0, 5);
// const sortedPrepaid = useMemo(() => sortedPrepaid1.slice(0, 5), [sortedPrepaid1]);

//   const sortedPostpaid1 = Object.entries(counts.postpaidCounts)
//     .sort((a, b) => b[1] - a[1])
//     .map((entry) => ({ name: entry[0], value: entry[1] }));
// //   const sortedPostpaid = sortedPostpaid1.slice(0, 5);
// const sortedPostpaid = useMemo(() => sortedPostpaid1.slice(0, 5), [sortedPostpaid1]);

//   const sortedPhones1 = Object.entries(counts.phoneCounts)
//     .sort((a, b) => b[1] - a[1])
//     .map((entry) => ({ name: entry[0], value: entry[1] }));
// //   const sortedPhones = sortedPhones1.slice(0, 5);
// const sortedPhones = useMemo(() => sortedPhones1.slice(0, 5), [sortedPhones1]);



  // Memoize filtered data
  const { data, data1 } = useMemo(() => {
    const emailPrefix = type[0] + '@vyadom.com';
    let data = accListAR;
    let data1 = accListOA;
    if (type[0] && type[1] === undefined) {
        const filteredData = accListAR.filter((item) => item.user === emailPrefix);
        const filteredData1 = accListOA.filter(
          (item) => item.username === emailPrefix
        );
        data = filteredData;
        data1 = filteredData1;
    } else if (type[1] && type[0] === '') {
      data = accListAR.filter(
        (item) => item.storeInvoice === findKeyByValue(storeNameList, type[1]),
      );
      data1 = accListOA.filter(
        (item) => item.storeInvoiceOA === findKeyByValue(storeNameList, type[1]),
      );
    } else if (type[1] && type[0]) {
      data = accListAR.filter(
        (item) =>
          item.storeInvoice === findKeyByValue(storeNameList, type[1]) && item.user === emailPrefix,
      );
      data1 = accListOA.filter(
        (item) =>
          item.storeInvoiceOA === findKeyByValue(storeNameList, type[1]) &&
          item.username === emailPrefix,
      );
    }
    return { data, data1 };
  }, [accListAR, accListOA, type]);

  // Memoize combinedArray and frequencyMap
  const { sortedAccessories } = useMemo(() => {
    const combinedArray = [];
    data.forEach((item) => {
      if (item.attachedAcc && item.attachedAcc.length > 0) {
        combinedArray.push(...item.attachedAcc);
      }
    });
    data1.forEach((item) => {
      if (item.attachedAccOnlyAccessory && item.attachedAccOnlyAccessory.length > 0) {
        combinedArray.push(...item.attachedAccOnlyAccessory);
      }
    });
    const frequencyMap = {};
    combinedArray.forEach((accessory) => {
      const accessoryName = accessory[1];
      if (frequencyMap[accessoryName]) {
        frequencyMap[accessoryName]++;
      } else {
        frequencyMap[accessoryName] = 1;
      }
    });
    const sortedAccessories = Object.entries(frequencyMap)
      .sort((a, b) => b[1] - a[1])
      .map((entry) => ({ name: entry[0], value: entry[1] }));
    return { sortedAccessories };
  }, [data, data1]);

  // Memoize counts
  const counts = useMemo(() => {
    const combinedCISArray = [...cisdata, ...eventCisData];
    return combinedCISArray?.reduce(
      (acc, obj) => {
        const planName = obj.planName;
        const phoneMake = obj?.phoneMake?.startsWith(
          'TCL 60 XE NXTPAPER 5G 128GB Extended Warranty Services',
        )
          ? 'TCL 60 XE NXTPAPER 5G 128GB Extended Warranty Services'
          : obj.phoneMake;
        const type = obj.connectionType;
        const sim = obj.simNumber;
        if (type === 'Prepaid') {
          acc.prepaidCounts[planName] = (acc.prepaidCounts[planName] || 0) + 1;
        } else if (type === 'Postpaid' && sim !== '') {
          acc.postpaidCounts[planName] = (acc.postpaidCounts[planName] || 0) + 1;
        }
        if (!phoneMake.includes('Bring Your Own Phone')) {
          acc.phoneCounts[phoneMake] = (acc.phoneCounts[phoneMake] || 0) + 1;
        }
        return acc;
      },
      { prepaidCounts: {}, postpaidCounts: {}, phoneCounts: {} },
    );
  }, [cisdata, eventCisData]);

  // Memoize sorted arrays
  const sortedPrepaid1 = useMemo(() =>
    Object.entries(counts.prepaidCounts)
      .sort((a, b) => b[1] - a[1])
      .map((entry) => ({ name: entry[0], value: entry[1] }))
  , [counts.prepaidCounts]);
  const sortedPrepaid = useMemo(() => sortedPrepaid1.slice(0, 5), [sortedPrepaid1]);

  const sortedPostpaid1 = useMemo(() =>
    Object.entries(counts.postpaidCounts)
      .sort((a, b) => b[1] - a[1])
      .map((entry) => ({ name: entry[0], value: entry[1] }))
  , [counts.postpaidCounts]);
  const sortedPostpaid = useMemo(() => sortedPostpaid1.slice(0, 5), [sortedPostpaid1]);

  const sortedPhones1 = useMemo(() =>
    Object.entries(counts.phoneCounts)
      .sort((a, b) => b[1] - a[1])
      .map((entry) => ({ name: entry[0], value: entry[1] }))
  , [counts.phoneCounts]);
  const sortedPhones = useMemo(() => sortedPhones1.slice(0, 5), [sortedPhones1]);

  const top4Accessories = useMemo(() => sortedAccessories.slice(0, 5), [sortedAccessories]);
// const top4Accessories = useMemo(() => sortedAccessories.slice(0, 5), [sortedAccessories]);
  const getPieChartData = useCallback(
    (value) => {
      switch (value) {
        case values[0]:
          return sortedPostpaid;
        case values[1]:
          return sortedPrepaid;
        case values[2]:
          return sortedPhones;
        case values[3]:
            
          return top4Accessories;
        default:
          return [];
      }
    },
    [sortedPostpaid, sortedPrepaid, sortedPhones, top4Accessories]
  );

  useEffect(() => {
    if (cisdata.length > 0) {
      setPieChartData(getPieChartData(selectedValue ));
    //   setSelectedValue(values[0]);
    }
  },[cisdata,getPieChartData, selectedValue]);

  const HandleInputChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setSelectedValue(value);
    setPieChartData(getPieChartData(value));
  };
  const transformForSheet = (data, nameKey = 'name') =>
    data.map((item) => ({
      Ranking: item.Ranking,
      [nameKey]: item.name,
      Count: item.count,
    }));

  const handleDownload = () => {
    const addRanking = (data) =>
      data.map((item, index) => ({ Ranking: index + 1, count: item.value, ...item }));
    // Add ranking numbers to both datasets
    const rankedData1 = addRanking(sortedPrepaid1);
    const rankedData2 = addRanking(sortedPostpaid1);
    const rankedData3 = addRanking(sortedPhones1);
    const rankedData4 = addRanking(sortedAccessories);

    const postpaidSheetData = transformForSheet(rankedData1, 'Plan Name');
    const prepaidSheetData = transformForSheet(rankedData2, 'Plan Name');
    const phonesSheetData = transformForSheet(rankedData3, 'Product Name');
    const accessoriesSheetData = transformForSheet(rankedData4, 'Product Name');

    // Convert JSON data to worksheet
    const wsPrepaid = XLSX.utils.json_to_sheet(prepaidSheetData, {
      header: ['Ranking', 'Plan Name', 'Count'],
    });
    const wsPostpaid = XLSX.utils.json_to_sheet(postpaidSheetData, {
      header: ['Ranking', 'Plan Name', 'Count'],
    });
    const wsPhones = XLSX.utils.json_to_sheet(phonesSheetData, {
      header: ['Ranking', 'Product Name', 'Count'],
    });
    const wsAccessories = XLSX.utils.json_to_sheet(accessoriesSheetData, {
      header: ['Ranking', 'Product Name', 'Count'],
    });
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Append worksheets to the workbook
    XLSX.utils.book_append_sheet(wb, wsPrepaid, values[0]);
    XLSX.utils.book_append_sheet(wb, wsPostpaid, values[1]);
    XLSX.utils.book_append_sheet(wb, wsPhones, values[2]);
    XLSX.utils.book_append_sheet(wb, wsAccessories, values[3]);

    // Write the workbook and trigger a download
    XLSX.writeFile(wb, `TopSeller_${selectedValue}_${datesString}.xlsx`);
  };
  return (
    <div className="pie-block block">
      <div className="block-head">
        <div className="block-title">
          <span>Top Sellers</span>
        </div>
        <div className="block-select">
          <select id="top-seller-select" value={selectedValue} onChange={HandleInputChange}>
            {values.map((name, index) => (
              <option key={index} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
        <div className="block-export-button">
          {/* <CustomButton
            btnLabel="FarihaExport"
            onClick={handleDownload}
            // className="edit-btn"
            disabled={PieChartData?.length === 0}
          />*/}
          <CustomButton
            btnLabel="Export"
            buttonType="success"
            onClick={handleDownload}
            customIcon={<CloudDownloadIcon fontSize='small'/>}
            type="submit"
            disabled={PieChartData?.length === 0|| isLoading}
          />
        </div>
      </div>
      {isLoading ? (
        <div className="spinner-container">
          <ReactLoading type="bars" color="#09f" height={100} width={100} />
        </div>
      ) : (
        <PieCharts
          PieChartData={PieChartData}
          legendLable={
            selectedValue === values[0] || selectedValue === values[1]
              ? 'Plan Name'
              : 'Product Name'
          }
        />
      )}
    </div>
  );
};

export default DashBoardPieChart;
